export const HAIR_COLORS = {
  raven: 0x1a0f08,
  chestnut: 0x5a2f16,
  mahogany: 0x4a170d,
  copper: 0xb45f2a,
  golden: 0xd8a642,
  ash: 0xc8bca8,
};

export const COMPLEXION_COLORS = {
  alabaster: 0xfff0e7,
  ivory: 0xf2cdb8,
  ochre: 0xc9854b,
  sienna: 0x9a6f43,
  umber: 0x6b3f25,
  sepia: 0x4a2b20,
};

export const EYE_COLORS = {
  amber: 0xc47a1a,
  azure: 0x406f9f,
  walnut: 0x4b2a16,
  slate: 0x8a8a84,
  emerald: 0x4f7d45,
  hazel: 0x7a5a2f,
};

export const CLOTHING_COLORS = {
  venetian_red: 0x8c2f1b,
  burnt_sienna: 0x9c4a24,
  yellow_ochre: 0xc69c43,
  raw_umber: 0x5a3a22,
  olive_green: 0x5f6f32,
  viridian: 0x2f6f5b,
  ultramarine: 0x263d8f,
  cerulean: 0x3f88b8,
  naples_yellow: 0xf0cf72,
  terre_verte: 0x6f7f5a,
};